import create from "zustand";
import { immerMiddleware } from "./immer-helper";

interface IPipelineStore {
    varsModalIsOpen: boolean;
    setVarsModalIsOpen: (isOpen: boolean) => void;

    debugModalIsOpen: boolean;
    setDebugModalIsOpen: (isOpen: boolean) => void;

    selectedStepId: string;
    setSelectedStepId: (selectedStepId: string) => void;

    arrowsRefs: Record<string, any>;
    setArrowRefs: (stepId: string, refs: any) => void;

    isSyncing: boolean;
    setIsSyncing: (isOpen: boolean) => void;

    pageDelta: { x: number; y: number };
    setPageDelta: (delta: { x: number; y: number }) => void;

    lastEdit: { lockedUntilTs: number; editorName: string; socketId: string };
    setLastEdit: (lastEdit: {
        lockedUntilTs: number;
        editorName: string;
        socketId: string;
    }) => void;

    isLocked: boolean;
    setIsLocked: (isLocked: boolean) => void;
}

const useRuntimeStore = create<IPipelineStore>(
    immerMiddleware((set, get) => ({
        varsModalIsOpen: false,
        setVarsModalIsOpen: (isOpen) => {
            set((state) => {
                state.varsModalIsOpen = isOpen;
            });
        },

        debugModalIsOpen: false,
        setDebugModalIsOpen: (isOpen) => {
            set((state) => {
                state.debugModalIsOpen = isOpen;
            });
        },

        selectedStepId: "",
        setSelectedStepId: (selectedStepId) => {
            set((state) => {
                state.selectedStepId = selectedStepId;
            });
        },

        arrowsRefs: {},
        setArrowRefs: (stepId, refs) => {
            set((state) => {
                state.arrowsRefs[stepId] = refs;
            });
        },

        isSyncing: false,
        setIsSyncing: (isSyncing) => {
            set((state) => {
                state.isSyncing = isSyncing;
            });
        },

        pageDelta: { x: 0, y: 0 },
        setPageDelta: (delta) => {
            set((state) => {
                state.pageDelta = delta;
            });
        },

        lastEdit: { lockedUntilTs: 0, editorName: "", socketId: "" },
        setLastEdit: (lastEdit) => {
            set((state) => {
                state.lastEdit = lastEdit;
            });
        },

        isLocked: false,
        setIsLocked: (isLocked) => {
            set((state) => {
                state.isLocked = isLocked;
            });
        },
    }))
);

export default useRuntimeStore;
